module.exports = "<div id=\"tree-temp\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/Tree.html
// module id = 86
// module chunks = 0